import Config from '../../Config';
import ConfigApi from '../../services/ConfigApi';

const TOGGLE_SHORTCUTMENU = 'MapTool/AppState/TOGGLE_SHORTCUTMENU';
const TOGGLE_MENU = 'MapTool/AppState/TOGGLE_MENU';
const TOGGLE_TAB = 'MapTool/AppState/TOGGLE_TAB';
const OPEN_MENU = 'MapTool/AppState/OPEN_MENU';
const CLOSE_MENU = 'MapTool/AppState/CLOSE_MENU';
const TOGGLE_FULLSCREEN = 'MapTool/AppState/TOGGLE_FULLSCREEN';

const OPEN_FAKE_FULLSCREEN = 'MapTool/AppState/OPEN_FAKE_FULLSCREEN';
const CLOSE_FAKE_FULLSCREEN = 'MapTool/AppState/CLOSE_FAKE_FULLSCREEN';
const TOGGLE_FAKE_FULLSCREEN = 'MapTool/AppState/TOGGLE_FAKE_FULLSCREEN';

const LOAD_APP_CONFIG = 'MapTool/AppState/LOAD_APP_CONFIG';
const LOAD_APP_CONFIG_COMPLETED = 'MapTool/AppState/LOAD_APP_CONFIG_COMPLETED';
const LOAD_APP_CONFIG_FAILED = 'MapTool/AppState/LOAD_APP_CONFIG_FAILED';
const TOGGLE_LOADING = 'Maptool/AppState/TOGGLE_LOADING';

const SET_LOADING = 'MapTool/AppState/SET_LOADING';

const SET_URL_PARAMS = 'Maptool/AppState/SET_URL_PARAMS';

const TOGGLE_LEGEND = 'Maptool/AppState/TOGGLE_LEGEND';

export function toggleLoadingAnimation(isLoading) {
  return { type: SET_LOADING, isLoading };
}

export function openFakeFullscreen(currentY) {
  return { type: OPEN_FAKE_FULLSCREEN, currentY };
}

export function closeFakeFullscreen() {
  return { type: CLOSE_FAKE_FULLSCREEN };
}

export function toggleFakeFullscreen() {
  return { type: TOGGLE_FAKE_FULLSCREEN };
}

export function openMenu() {
  return { type: OPEN_MENU };
}

export function closeMenu() {
  return { type: CLOSE_MENU };
}

export function toggleMenu() {
  return { type: TOGGLE_MENU };
}

export function toggleShortcutMenu() {
  return { type: TOGGLE_SHORTCUTMENU };
}

export function toggleFullScreen() {
  return { type: TOGGLE_FULLSCREEN };
}

export function toggleTab(payload) {
  return { type: TOGGLE_TAB, payload };
}

export function loadAppConfigCompleted(payload) {
  return { type: LOAD_APP_CONFIG_COMPLETED, payload };
}

export function loadAppConfigFailed(payload) {
  return { type: LOAD_APP_CONFIG_FAILED, payload };
}

export function loadAppConfig() {
  return dispatch => {
    dispatch({ type: LOAD_APP_CONFIG });

    ConfigApi.loadAppConfig()
      .then(res => dispatch(loadAppConfigCompleted(res.data)))
      .catch(err => dispatch(loadAppConfigFailed(err)));
  };
}

export function toggleLoading() {
  return { type: TOGGLE_LOADING };
}

export function setUrlParams(payload) {
  return { type: SET_URL_PARAMS, payload };
}

export function toggleLegend() {
  return { type: TOGGLE_LEGEND };
}

export function setLoading(isLoading) {
  return dispatch => {
    if (isLoading) {
      if (window.activeLoadingTimeout) {
        clearTimeout(window.activeLoadingTimeout);
      }
      window.activeLoadingTimeout = setTimeout(() => {
        dispatch(toggleLoadingAnimation(false));
      }, 10000);
    }
    dispatch(toggleLoadingAnimation(isLoading));
  };
}


// REDUCER
export default function AppStateReducer(state = Config.DEFAULT_APP_CONFIG, action = {}) {
  if (process.env.IS_DEV) {
    // console.log(action.type, action.payload);
  }

  switch (action.type) {
    case SET_LOADING:
      return Object.assign({}, state, { isLoading: action.isLoading });

    case OPEN_FAKE_FULLSCREEN:
      document.documentElement.classList.add('page-noscroll');
      return Object.assign({}, state, { isFakeFullscreenOpen: true, currentY: action.currentY });

    case CLOSE_FAKE_FULLSCREEN:
      document.documentElement.classList.remove('page-noscroll');
      window.scrollTo(0, state.currentY);
      return Object.assign({}, state, { isFakeFullscreenOpen: false, currentY: null });

    case TOGGLE_FAKE_FULLSCREEN:
      return Object.assign({}, state, { isFakeFullscreenOpen: !state.isFakeFullscreenOpen });

    case TOGGLE_SHORTCUTMENU:
      return Object.assign({}, state, { isShortcutMenuOpen: !state.isShortcutMenuOpen });

    case TOGGLE_MENU:
      return Object.assign({}, state, { isMenuOpen: !state.isMenuOpen });
    case TOGGLE_FULLSCREEN:
      if (window.$) {
        window.$(`#${Config.rootDivId}`).trigger('fullscreen.maptool', { isFullScreen: !state.isFullScreen });
      }
      return Object.assign({}, state, { isFullScreen: !state.isFullScreen });

    case TOGGLE_TAB:
      return Object.assign({}, state, { tabId: action.payload });

    case OPEN_MENU:
      return Object.assign({}, state, { isMenuOpen: true });

    case CLOSE_MENU:
      return Object.assign({}, state, { isMenuOpen: false });

    case LOAD_APP_CONFIG:
      return Object.assign({}, state, { isLoading: true });

    case LOAD_APP_CONFIG_COMPLETED:
      if (window.$) {
        window.$(`#${Config.rootDivId}`).trigger('fullscreen.maptool', { isFullScreen: state.isFullScreen });
      }
      return Object.assign({}, state, {
        products: action.payload.products,
        optionals: action.payload.optionals,
        basemaps: action.payload.basemaps,
        menuGroups: action.payload.menuGroups,
        productFamilies: action.payload.productFamilies,
        isLoading: false,
      });

    case LOAD_APP_CONFIG_FAILED:
      if (process.env.IS_DEV) {
        // console.error(action.payload);
      }

      return Object.assign({}, state, { isLoading: false });

    case TOGGLE_LOADING:
      return Object.assign({}, state);

    case SET_URL_PARAMS:
      if (window.$) {
        window.$(`#${Config.rootDivId}`).trigger('set_url.maptool', { urlParams: action.payload.urlParams });
      }
      return Object.assign({}, state, { urlParams: action.payload.urlParams });

    case TOGGLE_LEGEND:
      localStorage.setItem('additional-config', JSON.stringify(Object.assign({}, window.localStorage && JSON.parse(localStorage.getItem('additional-config')) ? JSON.parse(localStorage.getItem('additional-config')).legendVisible : {}, { legendVisible: !state.legendVisible })));
      return Object.assign({}, state, { legendVisible: !state.legendVisible });

    default:
      return Object.assign({}, state);
  }
}



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/App/AppState.js
 **/